// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"3d7dba38","426":"7149d815","453":"2657d72f","562":"999e5c5a"}[chunkId] + ".chunk.js";
};